import { Router } from '@angular/router';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'together-footer',
    templateUrl: './together.footer.html',
    standalone: false
})
export class TogetherFooterComponent {

  public currentYear: number =  new Date().getFullYear();

}
